import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { useLanguage } from '../../Providers/LanguageContext'
import { SpeechContext } from '../../Providers/SpeechWrapper';
import resource_es from '../../Audio_files/Resource Manager Audio Files/ES Audio Files/a. View Additional Resources Audio/view_additional_resources_audio_a_es.mp3'
import resource_en from '../../Audio_files/Resource Manager Audio Files/EN Audio Files/a. View Additional Resources Audio/view_additional_resources_audio_a.mp3';
import fisiYoutube from '../../images/Resource_manager/FISIBILITY-YOUTUBE.png'
import niv from '../../images/Resource_manager/NIV.png'
import nuevi from '../../images/Resource_manager/NUEVI TESTAMENTO 2020.png'

const ResourceManager = () => {
    const { language, currentLanguage } = useLanguage();
    const { currAudio, setCurrAudio, playing, setShowGif, setGifToShow, setGifPoints } = useContext(SpeechContext);
    useEffect(()=>{
        window.scrollTo({top:'0',behavior:'instant'})
    },[])
    const text = [
        {
            title: language.new_international_version,
            link: 'https://www.thenivbible.com',
            image: niv
        },
        {
            title: language.new_testament,
            link: 'https://2020newtestament.godaddysites.com',
            image: nuevi
        },
        {
            title: language.how_use_fisi_woutube,
            link: 'https://youtube.com/@FisibilityLite',
            image: fisiYoutube
        }
    ]

    useEffect(() => {
        if (playing) {
            if (currAudio) {
                if (!currAudio.paused) {
                    currAudio.pause()
                }
            }
            if (currentLanguage === "eng") {
                setCurrAudio(new Audio(resource_en))
            } else {
                setCurrAudio(new Audio(resource_es))
            }
        } else {
            if (currAudio) {
                if (!currAudio.paused) {
                    currAudio.pause()
                    setCurrAudio(null)
                }
            }
        }

        return () => {
            if (currAudio && !currAudio.paused) {
                currAudio.pause()
            }
        }
    }, [playing, currentLanguage])


    // useEffect(() => {
    //     console.log("currAudio", currAudio)
    //     if (currAudio) {
    //         if (!currAudio.paused) {
    //             currAudio.pause()
    //         }
    //         currAudio.play()
    //     }
    //     return () => {
    //         if (currAudio && !currAudio.paused) {
    //             currAudio.pause()
    //         }
    //     }
    // }, [currAudio])
    return (
        <>
            {/* {
                text.map((item, i) =>
                    <div id='all-news' key={i}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-xl-12 col-lg-12 col-md-12 col-12'>
                                    <div className='news-box'>
                                        <ul onClick={() => { }}>
                                            <li>
                                                <a href={item.link} target="_blank">
                                                    <div className='cnt-wrap'>
                                                        <h4>{item.title}</h4>
                                                        <i class="fa-solid fa-chevron-right"></i>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )
            } */}
            <div style={{
                background: 'linear-gradient(rgba(15, 36, 55, 1), rgb(255, 255, 255))',

            }}>
                {/* <div className="try_fisibilty_wrapper " style={{
                    transform: 'translateY(0%)',
                    margin: '0px',
                    justifyContent: 'start',

                }}>
                    <div className="container-fluid">
                        <p className="text-left">Resource Manager </p> </div>
                </div> */}
                <div className='container-fluid'>
                    <div className='task_head'>{language.resource_manager}</div>
                </div>
                <div className='container-fluid pt-3 mt-3' style={{
                    padding:'40px 20px',
             
                }}>
                    {/* <div className='resource_head_Wrapper' style={{ display: 'flex', justifyContent: 'center', fontFamily: 'Sans-serif' }}>
                        <h1>{language.resource_manager}</h1>
                    </div> */}
                    <div style={{ margin: '30px 0', display: 'flex', justifyContent: 'center' }}>

                        <div className='row' style={{
                            display: 'flex',
                            rowGap: '40px'
                        }}>
                            {
                                text.map((item, i) =>
                                    <div className='col-sm-12 col-md-12 col-lg-12 resouce_images_wrapper' style={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        columnGap: '30px'
                                    }}>
                                        <a href={item.link} target="_blank">
                                            <img src={item.image} style={{ height: '350px', width: '400px', borderRadius: '8px', boxShadow: '0px 4px 8px 4px rgba(0, 0, 0, 0.2)' }} />
                                        </a>
                                        <h5 style={{ margin: '10px 0' }}>{item.title}</h5>
                                    </div>
                                )

                            }
                            {/* <div className='col-md-4'>
                                <img src={fisiYoutube} style={{ height: '200px', width: '300px', borderRadius: '8px' }} />
                            </div>
                            <div className='col-md-4'>
                                <img src={fisiYoutube} style={{ height: '200px', width: '300px', borderRadius: '8px' }} />
                            </div> */}
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default ResourceManager